import { render } from "./RecoverPassForm.vue?vue&type=template&id=432de897&scoped=true"
import script from "./RecoverPassForm.vue?vue&type=script&lang=js"
export * from "./RecoverPassForm.vue?vue&type=script&lang=js"

import "./RecoverPassForm.vue?vue&type=style&index=0&id=432de897&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432de897"]])

export default __exports__